module.exports = __webpack_public_path__ + "img/PROXELIA.a49bcbb2.png";